import { CLASSIFICATIONS } from "./types"

export type AssignState = "none" | "some" | "all"

type Assignable = { id: string; checked: boolean }

export function assignStateOf(rows: readonly { checked: boolean }[]): AssignState {
  const assigned = rows.filter((row) => row.checked).length
  if (assigned === 0) return "none"
  return assigned === rows.length ? "all" : "some"
}

export const ASSIGNED_LABEL = { true: "Assigned", false: "Not assigned" } as const

export type StoreSet<T> = {
  key: string
  rows: T[]
  ids: string[]
  assigned: number
  state: AssignState
}

export function groupRowsBy<T extends Assignable>(
  rows: readonly T[],
  keyOf: (row: T) => string,
  compare: (a: string, b: string) => number = (a, b) => a.localeCompare(b),
): StoreSet<T>[] {
  return [...Map.groupBy(rows, keyOf).entries()]
    .toSorted(([a], [b]) => compare(a, b))
    .map(([key, members]) => ({
      key,
      rows: members,
      ids: members.map((row) => row.id),
      assigned: members.filter((row) => row.checked).length,
      state: assignStateOf(members),
    }))
}

const OUTLET = "Outlet"

function gradeRank(grade: string) {
  const index = CLASSIFICATIONS.indexOf(grade as (typeof CLASSIFICATIONS)[number])
  return index === -1 ? CLASSIFICATIONS.length : index
}

export type GradeChip = StoreSet<Assignable> & { label: string }

export function gradeChips(
  rows: readonly (Assignable & { classification: string })[],
): GradeChip[] {
  return groupRowsBy(
    rows,
    (row) => row.classification,
    (a, b) => gradeRank(a) - gradeRank(b) || a.localeCompare(b),
  ).map((set) => ({ ...set, label: set.key === OUTLET ? OUTLET : `Grade ${set.key}` }))
}
